import { SVSummaryCardItem } from '@/types/common';
import { buildAddress } from '@/utils/address';
import {
  RecipientDetail,
  RecipientRequestDetail,
} from '@/types/wireRecipients';
import { SVSummaryCard } from '@/components/core';

type WireRecipientDetailsInfoProps = {
  wireRecipientInfo: RecipientDetail | RecipientRequestDetail;
};

export default function WireRecipientDetailsInfo({
  wireRecipientInfo,
}: WireRecipientDetailsInfoProps) {
  const {
    accountName,
    recipientNickName,
    currentAddressCity,
    currentAddressCountryCode,
    currentAddressLine1,
    currentAddressLine2,
    currentAddressPostalCode,
    currentAddressState,
  } = wireRecipientInfo;

  const items: SVSummaryCardItem[] = [
    {
      label: 'Name on Account',
      text: accountName,
    },
    {
      label: 'Nickname',
      text: recipientNickName,
    },
    {
      label: 'Address Associated with the Account',
      text: buildAddress({
        line1: currentAddressLine1,
        line2: currentAddressLine2,
        city: currentAddressCity,
        country: currentAddressCountryCode,
        postalCode: currentAddressPostalCode,
        state: currentAddressState || '',
      }),
    },
  ];

  return <SVSummaryCard label="Wire Recipient Info" items={items} />;
}
